<main>
  <section>

      <mat-form-field appearance="fill">
        <mat-label>Date de début de publication</mat-label>
        <input matInput [matDatepicker]="start" disabled [(ngModel)]="startDate">
        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
        <mat-datepicker #start disabled="false"></mat-datepicker>
      </mat-form-field>



      <mat-form-field appearance="fill">
        <mat-label>Date de fin de publication</mat-label>
        <input matInput [matDatepicker]="end" disabled [(ngModel)]="endDate">
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end disabled="false"></mat-datepicker>
      </mat-form-field>



  </section>


  <section>
    <button mat-raised-button
            color="accent" (click)="setDate()">
      {{'validate' | translation}}
    </button>

    <button mat-raised-button (click)="close()"
            color="warning">
      {{'cancel' | translation}}
    </button>
  </section>


</main>
